import produce from 'immer';

const INITIAL_STATE = {
  profile: null,
  data: null,
  loading: false,
};

export default function user(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@auth/SIGN_IN_SUCCESS': {
        draft.profile = action.payload.user;
        break;
      }
      case '@user/UPDATE_PROFILE_REQUEST': {
        draft.data = action.payload.data;
        break;
      }
      case '@user/UPDATE_PROFILE_SUCCESS': {
        draft.data = action.payload.data;
        break;
      }
      case '@user/SIGN_OUT': {
        draft.profile = null;
        break;
      }
      case '@user/CHANGE_PASSWORD_REQUEST': {
        draft.data = action.payload.data;
        break;
      }
      case '@user/CHANGE_PASSWORD_RESPONSE': {
        draft.data = action.payload.data;
        break;
      }
      case '@user/GET_DATA_PROFILE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@user/GET_DATA_PROFILE_RESPONSE': {
        draft.loading = false;
        draft.data = action.payload.data;
        break;
      }
      default:
    }
  });
}
